export default {
  CREATED: 1,
  PROPOSAL_SENT: 2,
  PROPOSAL_ACCEPTED: 3,
  CONFIRMED_TRANSPORTER: 4,
  DEFINED_DRIVER_AND_VEHICLE: 5,
  APPROVAL_DRIVER_AND_VEHICLE: 6,
  CHECKLIST_APPROVAL: 7,
  VEHICLE_MIRRORED: 8,
  WAITING_COLLECTION: 9,
  INVOICE_ISSUED: 10,
  AVAILABLE_CTE: 11,
  AVAILABLE_MDFE: 12,
  AVAILABLE_PLV: 13,
  COLLECTED: 14,
  ON_ROUTE: 15,
  ON_DESTINY: 16,
  DELIVERED: 17,
  PARTIAL_DELIVERY: 18,
  REFUSED_DELIVERY: 19,
  AVAILABLE_CANHOTO: 20,
  ON_ROUTE_DC: 21,
  DELIVERED_DC: 22,
  UNSUCCESSFUL: 23,
  ON_ROUTE_AIRPORT: 24,
  DELIVERED_AIRPORT: 25,
  BOARDED: 26,
  TAKEOFF: 27,
  LANDED: 28,
  UNLOAD: 29,
  RELEASED: 30,
  PO: 31
};
